// extracted by mini-css-extract-plugin
export default {"GroupGiftProgress":"GroupGiftProgress-styles__GroupGiftProgress__necf4","GroupGiftProgress__fill":"GroupGiftProgress-styles__GroupGiftProgress__fill__sA8cA"};